import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import MainPage from './mainPage';
import InvitePage from './pages/invitePage';
import LoginPage from './pages/loginPage';
import DownloadPage from './pages/downloadPage';
import GoodsListPage from './pages/goodsListPage';
import GoodsDetailPage from './pages/goodsDetailPage';
import SuccessPage from './pages/successPage';
import ProtocolPage from './pages/protocolPage';
import SharePage from './pages/sharePage';
import BroadbandAccess from './pages/broadbandAccess';
import StockGoodsDetailPage from './pages/stockGoodsDetailPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />}>
          <Route path="/" element={<GoodsListPage />} />
          <Route path="/goods" element={<GoodsDetailPage />} />
          <Route path="/invite" element={<InvitePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/protocol" element={<ProtocolPage />} />
          <Route path="/share" element={<SharePage />} />
          <Route path="/broadbandAccess" element={<BroadbandAccess />} />
          <Route path="/stock" element={<StockGoodsDetailPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
